import { t } from 'i18next';
import { createHashRouter } from 'react-router-dom';
import ErrorBoundary from './individual/components/common/ErrorBoundary';
import Layout from './individual/components/common/Layout';
import AgeRestrictionView from './individual/views/AgeRestriction';
import BackgroundView from './individual/views/BackgroundView';
import LanguageConfirmationView from './individual/views/LanguageConfirmation';
import { ManualUWResult } from './individual/views/ManualUWResult';
import ProfilingBlock from './individual/views/ProfilingBlock';
import PurchaseView from './individual/views/PurchaseView';
import { TechnicalError } from './individual/views/TechnicalError';

const getRouter = () =>
  createHashRouter([
    {
      path: '/',
      element: (
        <ErrorBoundary>
          <Layout />
        </ErrorBoundary>
      ),
      errorElement: <TechnicalError />,
      children: [
        {
          index: true,
          element: <BackgroundView />,
        },
        {
          path: t('paths.insuranceContent'),
          element: <PurchaseView />,
        },
        {
          path: t('paths.language'),
          element: <LanguageConfirmationView />,
        },
        {
          path: t('paths.ageLimit'),
          element: <AgeRestrictionView />,
        },
        {
          path: t('paths.block'),
          element: <ProfilingBlock />,
        },
        {
          path: t('paths.result'),
          element: <ManualUWResult />,
        },
      ],
    },
  ]);

export default getRouter;
